export function getTimeseriesData(
  data = [{ name: 1627816410000, value: 310 }],
  monthsBack = 5
) {
  var previous = data[0].value;
  for (let step = 1; step < monthsBack; step++) {
    var date = new Date(data[0].name);
    date.setMonth(date.getMonth() - step);
    var random = Math.random() * 2 - 1;
    var newValue = Math.round(previous + previous * 0.15 * random);
    data.push({ name: date.valueOf(), value: newValue });
    previous = newValue;
  }
  return data;
}
